export default {
  name: "RecentDocuments",

  data() {
    return ({
      documents: [
        {
          id: 1,
          title: "Q4 2025 Performance Report",
          updated: "2 hours ago",
          size: "2.4 MB",
          icon: "far fa-file-pdf text-danger",
        },
        {
          id: 2,
          title: "Energy Consumption Analysis",
          updated: "yesterday",
          size: "1.8 MB",
          icon: "far fa-file-excel text-success",
        },
        {
          id: 3,
          title: "Incident Report - Nov 28",
          updated: "3 days ago",
          size: "856 KB",
          icon: "far fa-file-word text-primary",
        },
        {
          id: 4,
          title: "Maintenance Schedule - December",
          updated: "1 week ago",
          size: "3.2 MB",
          icon: "far fa-file-pdf text-danger",
        },
      ],
    });
  },
};
